import JwtService from '@/core/services/jwt.service';

export default {
  props: {
    usarPreferenciaJanela: {type: Boolean, default: true}
  },
  data() {
    return {
      deslocamentoX: 0,
      deslocamentoY: 0,
      arrasto: null,
      dimensoes: null,
      redimensionamento: null
    };
  }, 
  computed: {
    permiteMover() {
      return !this.fullscreen && !this.nooverflow && this.movel !== false;
    },
    permiteRedimensionar() {
      return !this.fullscreen && !this.nooverflow && this.redimensionavel !== false;
    },
    chaveArmazenamento() {
      if (!this.permiteMover && !this.permiteRedimensionar) return null;
      if (this.chavePreferenciaJanela) return this.chavePreferenciaJanela;
      const {idEmitenteML, usuario} = this.$store.getters;
      const tela = this.idJanela || this.$parent?.$options.name;
      return tela && idEmitenteML && usuario
        ? 'modalJanela:' + JSON.stringify([tela, idEmitenteML, usuario]) : null;
    },
    estiloJanela() {
      if (!this.dimensoes && !this.deslocamentoX && !this.deslocamentoY) return;
      if (!this.permiteRedimensionar) {
        return {transform: `translate(clamp(calc(50% - 50vw), ${this.deslocamentoX}px, calc(50vw - 50%)), clamp(calc(50% - 50dvh), ${this.deslocamentoY}px, calc(50dvh - 50%)))`};
      }
      return {
        ...this.dimensoes,
        transform: 'translate(' + this.deslocamentoX + 'px,' + this.deslocamentoY + 'px)'
      };
    }
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.restaurarJanela);
  },
  watch: {
    usarPreferenciaJanela() {
      if (this.janelaVisivel) this.$nextTick(this.restaurarJanela);
    }
  },
  methods: {
    async finalizarAjuste() {
      if (!this.arrasto && !this.redimensionamento) return;
      this.arrasto = null;
      this.redimensionamento = null;
      if (!this.chaveArmazenamento || !this.usarPreferenciaJanela) return;
      await this.$nextTick();
      if (!this.janelaVisivel || !this.$refs.conteudo || !this.usarPreferenciaJanela) return;
      const {left, top, width, height} = this.$refs.conteudo.getBoundingClientRect();
      try {
        const ajuste = this.permiteRedimensionar ? {left, top, width, height} : {left, top};
        JwtService.salvarGenerico(this.chaveArmazenamento, JSON.stringify(ajuste));
      } catch { /* A janela continua utilizável se o navegador bloquear o armazenamento. */ }
    },
    restaurarJanela() {
      this.centralizarJanela();
      if (!this.chaveArmazenamento || !this.janelaVisivel || !this.usarPreferenciaJanela) return;
      let salva;
      try {
        salva = JSON.parse(window.localStorage.getItem(this.chaveArmazenamento));
      } catch { return; }
      if (!salva || ![salva.left, salva.top].every(Number.isFinite)) return;
      if (!this.permiteRedimensionar) {
        const caixa = this.$refs.conteudo?.getBoundingClientRect();
        if (!caixa) return;
        const margemX = (this.$refs.areaJanela.clientWidth - caixa.width) / 2;
        const margemY = (this.$refs.areaJanela.clientHeight - caixa.height) / 2;
        this.deslocamentoX = Math.min(margemX, Math.max(-margemX, salva.left - margemX));
        this.deslocamentoY = Math.min(margemY, Math.max(-margemY, salva.top - margemY));
        return;
      }
      if (![salva.width, salva.height].every(Number.isFinite) ||
          salva.width <= 0 || salva.height <= 0) return;
      const dialogo = this.$refs.conteudo?.offsetParent?.getBoundingClientRect();
      if (!dialogo) return;
      const largura = Math.min(salva.width, this.$refs.areaJanela.clientWidth);
      const altura = Math.min(salva.height, this.$refs.areaJanela.clientHeight);
      this.dimensoes = {
        width: largura + 'px', height: altura + 'px',
        left: (Math.max(0, Math.min(salva.left, this.$refs.areaJanela.clientWidth - largura)) - dialogo.left) + 'px',
        top: (Math.max(0, Math.min(salva.top, this.$refs.areaJanela.clientHeight - altura)) - dialogo.top) + 'px'
      };
    },
    restaurarPadraoJanela() {
      this.centralizarJanela();
      try {
        JwtService.removerGenerico(this.chaveArmazenamento);
      } catch { /* O tamanho original também se aplica quando o armazenamento está bloqueado. */ }
    },
    centralizarJanela() {
      this.arrasto = null;
      this.dimensoes = null;
      this.redimensionamento = null;
      this.deslocamentoX = 0;
      this.deslocamentoY = 0;
    },
    iniciarArrasto(evento) {
      if (!this.permiteMover || !evento.isPrimary || evento.button !== 0 || evento.target.closest('.btn')) return;
      const caixa = this.$refs.conteudo.getBoundingClientRect();
      this.arrasto = {
        ponteiro: evento.pointerId,
        x: evento.clientX, y: evento.clientY,
        inicioX: this.deslocamentoX, inicioY: this.deslocamentoY,
        minX: Math.min(0, -caixa.left), maxX: Math.max(0, this.$refs.areaJanela.clientWidth - caixa.right),
        minY: Math.min(0, -caixa.top), maxY: Math.max(0, this.$refs.areaJanela.clientHeight - caixa.bottom)
      };
      evento.currentTarget.setPointerCapture(evento.pointerId);
    },
    moverJanela(evento) {
      const origem = this.arrasto;
      if (!origem || evento.pointerId !== origem.ponteiro) return;
      this.deslocamentoX = origem.inicioX + Math.max(origem.minX, Math.min(origem.maxX, evento.clientX - origem.x));
      this.deslocamentoY = origem.inicioY + Math.max(origem.minY, Math.min(origem.maxY, evento.clientY - origem.y));
    },
    iniciarRedimensionamento(evento) {
      if (!this.permiteRedimensionar || !evento.isPrimary || evento.button !== 0) return;
      const conteudo = this.$refs.conteudo;
      const caixa = conteudo.getBoundingClientRect();
      const dialogo = conteudo.offsetParent.getBoundingClientRect();
      this.redimensionamento = {
        ponteiro: evento.pointerId, x: evento.clientX, y: evento.clientY,
        largura: caixa.width, altura: caixa.height,
        limiteX: this.$refs.areaJanela.clientWidth - caixa.left, limiteY: this.$refs.areaJanela.clientHeight - caixa.top
      };
      this.dimensoes = {
        left: (caixa.left - dialogo.left - this.deslocamentoX) + 'px',
        top: (caixa.top - dialogo.top - this.deslocamentoY) + 'px',
        width: caixa.width + 'px', height: caixa.height + 'px'
      };
      evento.currentTarget.setPointerCapture(evento.pointerId);
    },
    redimensionar(evento) {
      const inicio = this.redimensionamento;
      if (!inicio || evento.pointerId !== inicio.ponteiro) return;
      const largura = inicio.largura + evento.clientX - inicio.x;
      const altura = inicio.altura + evento.clientY - inicio.y;
      this.dimensoes.width = Math.min(inicio.limiteX, Math.max(Math.min(700, inicio.largura), largura)) + 'px';
      this.dimensoes.height = Math.min(inicio.limiteY, Math.max(Math.min(320, inicio.altura), altura)) + 'px';
    },
  }
};
